import { GatsbyImage } from "gatsby-plugin-image"
import { Checkmark } from "nzk-react-components"
import React from "react"
import styled from "styled-components"
import getGatsbyImage from "utils/getGatsbyImage"
import { FONT_FAMILIES } from "../../../styles/Theme"
import StrapiButton from "../StrapiButton"

const Wrapper = styled.div`
  position: relative;
  min-height: 300px;
  padding: 0 20px;
  max-width: 100vw;
  overflow: hidden;
  > :first-child {
    position: absolute !important;
    height: 100%;
    width: 100%;
    left: 0;
    bottom: 0;
    z-index: -1;
  }
  > .trustpilot-banner {
    background-color: rgba(0, 0, 0, 0.3);
  }
`

const Content = styled.div`
  max-width: 900px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  > * {
    flex: 1;
    width: 100%;
    height: 100%;
  }
  > :first-child {
    width: 40%;
    transform: translateX(-50vw);
    max-width: 370px;
  }
  > :nth-child(2) {
    width: 60%;
    transform: translateX(50vw);
  }
  img {
    object-fit: contain !important;
  }
  color: #fff;
  @media (max-width: 750px) {
    flex-direction: column-reverse;
    align-items: center;
    > * {
      width: 100% !important;
      text-align: center;
    }
  }

  > :first-child {
    animation: animate-left 0.6s ease-in-out forwards 0.3s;
  }
  > :nth-child(2) {
    animation: animate-right 0.6s ease-in-out forwards 0.3s;
  }
  @keyframes animate-left {
    from {
      transform: translateX(-50vw);
    }
    to {
      transform: translateX(0);
    }
  }
  @keyframes animate-right {
    from {
      transform: translateX(50vw);
    }
    to {
      transform: translateX(0);
    }
  }
`

const RightContent = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  margin: auto 0;
  padding-left: 30px;
  padding-bottom: 30px;

  @media (max-width: 750px) {
    padding-left: 0;
  }
`

const KeyPointsSection = styled.div`
  > h1:first-child {
    font-weight: normal;
    font-size: 1.9rem;
    line-height: 1.3;
    ${FONT_FAMILIES.rammetto};
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    margin-bottom: 10px;
    > :first-child {
      transform: translateY(3px);
      height: 20px;
      width: 20px;
      margin-right: 6px;
      svg {
        width: 20px;
        height: 20px;
      }
      path:nth-child(2),
      path:nth-child(3),
      path:nth-child(4) {
        fill: #98c355;
      }
    }
  }
  margin-bottom: 15px;
  @media (max-width: 750px) {
    padding-left: 0;
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  > * {
    margin-right: 14px;
  }
  > :last-child {
    margin-right: 0;
  }
  @media (max-width: 750px) {
    justify-content: center;
  }
`

interface IProps {
  backgroundImage: any
  image: any
  title: string
  slug: string
  points: {
    icon: any
    texts: string[]
  }
  buttons: {
    value: string
    targetUrl?: string
    theme?: string
    action?: string
  }[]
}

const EngagingBanner = (props: IProps) => {
  return (
    <Wrapper>
      <GatsbyImage
        image={getGatsbyImage(props.backgroundImage.localFile)}
        alt="Engaging banner"
      />
      <div
        id={props.slug}
        style={{
          top: "-95px",
          display: "block",
          visibility: "hidden",
          position: "relative",
        }}
      />
      <Content>
        <GatsbyImage
          image={getGatsbyImage(props.image.localFile)}
          alt={props.title || ""}
        />
        <RightContent>
          <KeyPointsSection>
            <h1>{props.title}</h1>
            <ul>
              {props.points.texts.map((p, i) => (
                <li key={i}>
                  <Checkmark width="20px" height="20px" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </KeyPointsSection>
          {(props.buttons || []).length > 0 && (
            <Buttons>
              {props.buttons.map((b, i) => {
                // @ts-ignore
                return <StrapiButton key={`engaging-buttons-${i}`} {...b} />
              })}
            </Buttons>
          )}
        </RightContent>
      </Content>
    </Wrapper>
  )
}

export default EngagingBanner
